<div class="full-height full-width">
    <div *ngIf="data.title" class="full-width centerWithFlex title-align" style="height: 20%;">
        <span>{{data.title}}</span>
    </div>
    <div class="full-width centerWithFlex" style="height: 65%;">
        <span style="text-align: center;">{{data.subject}}</span>
    </div>
    <div class="centerWithFlex full-width" style="height: 15%;">
        <button class="btn btn-outline-secondary proceed-btn" (click)="closePop($event, true)">{{data.submitButton}}</button>
        <button class="btn btn-outline-secondary cancel-btn" (click)="closePop($event, false)">{{data.cancelButton}}</button>
    </div>
</div>
